'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import MercadoPagoBadge from '@/components/payments/MercadoPagoBadge';

interface CTASectionProps {
  className?: string;
}

const CTASection = ({ className = '' }: CTASectionProps) => {
  return (
    <section className={`py-20 lg:py-32 relative overflow-hidden text-white ${className}`} style={{ backgroundImage: 'linear-gradient(135deg, #06213f 0%, #0f3f87 34%, #2c78fb 68%, #3ee0be 100%)' }}>
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-10 left-20 w-72 h-72 bg-[#2c78fb]/20 rounded-full blur-3xl" />
        <div className="absolute bottom-10 right-20 w-96 h-96 bg-[#3ee0be]/20 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className="inline-flex items-center space-x-2 px-5 py-2.5 bg-white/14 backdrop-blur-md rounded-full mb-8 border border-white/20">
          <Icon name="RocketLaunchIcon" size={20} className="text-[#9ff9de]" />
          <span className="text-sm text-white font-semibold">Comienza tu Transformación Ahora</span>
        </div>

        <h2 className="text-4xl lg:text-6xl font-black text-white mb-6 leading-tight">
          Lleva tu Negocio al{' '}
          <span className="bg-clip-text text-transparent" style={{ backgroundImage: 'linear-gradient(135deg, #ffffff 0%, #b8fff0 45%, #7dd3fc 100%)' }}>
            Siguiente Nivel
          </span>
        </h2>

        <p className="text-xl lg:text-2xl text-white/95 mb-10 max-w-3xl mx-auto leading-relaxed">
          Únete a LynMet hoy y accede a coaching empresarial de nivel mundial impulsado por inteligencia artificial. Sin contratos, sin compromisos de largo plazo.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <Link
            //href="/register"
            href="/start"
            className="btn-primary-app group inline-flex items-center justify-center space-x-2 px-10 py-5 text-lg"
          >
            <span>Comenzar Gratis Ahora</span>
            <Icon name="ArrowRightIcon" size={24} className="group-hover:translate-x-1 transition-transform" />
          </Link>

          <Link
            href="/start"
            className="btn-secondary-app-dark inline-flex items-center justify-center space-x-2 px-10 py-5 text-lg"
          >
            <Icon name="SparklesIcon" size={24} />
            <span>Probar Coach IA</span>
          </Link>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-8 text-white/90">
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircleIcon" size={24} className="text-green-300" />
            <span className="font-medium">Sin tarjeta de crédito</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="BoltIcon" size={24} className="text-yellow-300" />
            <span className="font-medium">Tokens de bienvenida incluidos</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="ClockIcon" size={24} className="text-blue-300" />
            <span className="font-medium">Listo en 2 minutos</span>
          </div>
        </div>

        <div className="mt-10 flex justify-center">
          <MercadoPagoBadge
            variant="plain"
            className="px-1 py-1"
            caption="Pagos y suscripciones operados con Mercado Pago."
          />
        </div>
      </div>
    </section>
  );
};

export default CTASection;
